// Announcement Carousel
(function () {
  const ROOT_ID = 'AnnouncementSlider';

  let lastTotal = null;
  let lastIndex = null;
  let isApplying = false;

  function ensureLiveRegion(root) {
    let live = root.querySelector('#AnnouncementSliderStatus');
    if (!live) {
      live = document.createElement('div');
      live.id = 'AnnouncementSliderStatus';

      // SR-only
      live.style.position = 'absolute';
      live.style.width = '1px';
      live.style.height = '1px';
      live.style.padding = '0';
      live.style.margin = '-1px';
      live.style.overflow = 'hidden';
      live.style.clip = 'rect(0, 0, 0, 0)';
      live.style.whiteSpace = 'nowrap';
      live.style.border = '0';

      live.setAttribute('aria-live', 'polite');
      live.setAttribute('aria-atomic', 'true');

      root.appendChild(live);
    }
    return live;
  }

  function getSlides(root) {
    // Most reliable: direct children of the Flickity slider track
    const track = root.querySelector('.flickity-slider');
    if (!track) return [];
    return Array.from(track.children);
  }

  function getSelectedIndex(slides) {
    const idx = slides.findIndex((el) => el.classList.contains('is-selected'));
    return idx === -1 ? 0 : idx;
  }

  function setIfDifferent(el, name, value) {
    if (!el) return;
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  function applyA11y(root) {
    if (isApplying) return;
    isApplying = true;

    try {
      // Buttons
      const prevBtn =
        root.querySelector('.flickity-prev-next-button.flickity-prev') ||
        root.querySelector('.flickity-prev-next-button.flickity-previous');

      const nextBtn = root.querySelector('.flickity-prev-next-button.flickity-next');

      if (prevBtn) {
        setIfDifferent(prevBtn, 'title', 'Previous announcement');
        setIfDifferent(prevBtn, 'aria-label', 'Previous announcement');
      }
      if (nextBtn) {
        setIfDifferent(nextBtn, 'title', 'Next announcement');
        setIfDifferent(nextBtn, 'aria-label', 'Next announcement');
      }

      // Slides + live region
      const slides = getSlides(root);
      const total = slides.length;
      if (!total) return;

      if (!root.getAttribute('aria-label') && !root.getAttribute('aria-labelledby')) {
        setIfDifferent(root, 'aria-label', 'Announcements');
      }

      // Only set slide attributes once per total change
      if (lastTotal !== total) {
        slides.forEach((slide, i) => {
          setIfDifferent(slide, 'role', 'group');
          setIfDifferent(slide, 'aria-roledescription', 'slide');

        });
        lastTotal = total;
      }

      const idx = getSelectedIndex(slides);
      const live = ensureLiveRegion(root);

      // Only announce when index actually changes
      if (lastIndex !== idx) {
        live.textContent = `Announcement ${idx + 1} of ${total}`;
        lastIndex = idx;
      }
    } finally {
      isApplying = false;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.getElementById(ROOT_ID);
    if (!root) return;

    // Initial apply
    applyA11y(root);

    // Observe ONLY the slider area (not the whole body)
    const observer = new MutationObserver(() => applyA11y(root));
    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'] // class changes when .is-selected moves
    });

    // Also re-check on arrow key nav
    document.addEventListener('keyup', (e) => {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') applyA11y(root);
    });
  });
})();

// Header Search Icon Aria Sync
(function () {
  const openBtn = document.querySelector('.js-search-header');
  const dialog = document.getElementById('HeaderSearch');
  const closeBtn = document.getElementById('SearchClose');
  const input = dialog?.querySelector('.site-header__search-input');

  if (!openBtn || !dialog) return;

  function openSearch() {
    dialog.classList.add('is-active');
    openBtn.setAttribute('aria-expanded', 'true');

    // Move focus into dialog
    setTimeout(() => input?.focus(), 50);
  }

  function closeSearch() {
    dialog.classList.remove('is-active');
    openBtn.setAttribute('aria-expanded', 'false');

    // Return focus to trigger button
    openBtn.focus();
  }

  openBtn.addEventListener('click', openSearch);
  closeBtn?.addEventListener('click', closeSearch);

  // Close on Escape (expected behavior)
  dialog.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });
})();

// Header Cart Aria Sync
(function () {
  const btn = document.querySelector('.js-drawer-open-cart');
  const drawer = document.getElementById('CartDrawer');

  if (!btn || !drawer) return;

  function sync() {
    // adjust class name if your theme uses something different
    const isOpen =
      drawer.classList.contains('is-active') ||
      drawer.classList.contains('drawer--is-open') ||
      drawer.getAttribute('aria-hidden') === 'false';

    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  sync();

  const obs = new MutationObserver(sync);
  obs.observe(drawer, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });

  // Optional: return focus to button when drawer closes (if your close button has a known selector)
  const closeBtn = drawer.querySelector('[data-drawer-close], .js-drawer-close, .drawer__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => setTimeout(() => btn.focus(), 0));
  }
})();

// Footer links
(function () {
  const VISUALLY_HIDDEN_CLASS = 'visually-hidden';

  function enhanceFooter() {
    const footer = document.querySelector('footer, .site-footer');
    if (!footer) return;

    // Find the footer rich text containers (theme-dependent; these cover most Shopify themes)
    const blocks = footer.querySelectorAll('.rte, .footer__item-padding, .footer__text, .collapsible-content__inner');
    if (!blocks.length) return;

    blocks.forEach((block) => {
      // Only touch the location block(s) that contain tel links
      if (!block.querySelector('a[href^="tel:"]')) return;

      // 1) Phone aria-labels
      const telLinks = block.querySelectorAll('a[href^="tel:"]');
      telLinks.forEach((a) => {
        if (a.hasAttribute('aria-label')) return;

        const numberText = a.textContent.replace(/\s+/g, ' ').trim();
        const href = (a.getAttribute('href') || '').trim();

        let location = '';
        if (href.includes('15106794878') || numberText.includes('679-4878')) location = 'Albany Bakery Cafe';
        else if (href.includes('15107356910') || numberText.includes('735-6910')) location = 'Rockridge Bakery Cafe';
        else if (href.includes('15105476400') || numberText.includes('547-6400')) location = 'Wholesale Bakery';

        a.setAttribute('aria-label', location ? `Call ${location} at ${numberText}` : `Call ${numberText}`);
      });

      // 2) Add "Address:" label before each street line within each <p> that contains a tel link
      // The footer markup is typically: Location name <br> Street line <br> City/State/ZIP <br> <a tel>Phone</a>
      const ps = block.querySelectorAll('p');
      ps.forEach((p) => {
        if (!p.querySelector('a[href^="tel:"]')) return; // only paragraphs that include a phone link
        if (p.querySelector('[data-a11y-address-label="1"]')) return; // don't double-insert

        const nodes = Array.from(p.childNodes);

        // Find the first <br>
        const firstBrIndex = nodes.findIndex(
          (n) => n.nodeType === Node.ELEMENT_NODE && n.nodeName === 'BR'
        );
        if (firstBrIndex === -1) return;

        // Find the next meaningful text node after the first <br> that looks like a street line
        let streetNode = null;
        for (let i = firstBrIndex + 1; i < nodes.length; i++) {
          const n = nodes[i];

          // Stop if we hit the tel link before finding the street line
          if (n.nodeType === Node.ELEMENT_NODE && n.nodeName === 'A' && n.getAttribute('href')?.startsWith('tel:')) {
            break;
          }

          if (n.nodeType === Node.TEXT_NODE) {
            const t = (n.nodeValue || '').replace(/\s+/g, ' ').trim();
            if (!t) continue;

            // Street lines usually start with a number: "901 Gilman Street STE B"
            if (/^\d{2,6}\b/.test(t)) {
              streetNode = n;
              break;
            }
          }
        }

        if (!streetNode) return;

        const label = document.createElement('span');
        label.className = VISUALLY_HIDDEN_CLASS;
        label.setAttribute('data-a11y-address-label', '1');
        label.textContent = 'Address: ';

        // Insert before the street line text node
        p.insertBefore(label, streetNode);
      });
    });
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceFooter);
  } else {
    enhanceFooter();
  }

  // Theme editor / section refresh
  document.addEventListener('shopify:section:load', enhanceFooter);
})();

// Navigation fixes
// (function () {
//   const nav = document.querySelector('.site-nav.site-navigation.small--hide');
//   if (!nav) return;

//   const toggles = Array.from(nav.querySelectorAll('.site-nav__dropdown-toggle'));

//   function closeAll(except = null) {
//     toggles.forEach((btn) => {
//       if (except && btn === except) return;
//       const id = btn.getAttribute('aria-controls');
//       const menu = id ? document.getElementById(id) : null;
//       btn.setAttribute('aria-expanded', 'false');
//       if (menu) menu.hidden = true;
//     });
//   }

//   toggles.forEach((btn) => {
//     const id = btn.getAttribute('aria-controls');
//     const menu = id ? document.getElementById(id) : null;
//     if (!menu) return;

//     // Ensure closed on load
//     btn.setAttribute('aria-expanded', 'false');
//     menu.hidden = true;

//     btn.addEventListener('click', (e) => {
//       e.preventDefault();
//       const isOpen = btn.getAttribute('aria-expanded') === 'true';
//       closeAll(btn);
//       btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
//       menu.hidden = isOpen;

//       // Focus first submenu item when opening
//       if (!isOpen) {
//         const first = menu.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
//         if (first) first.focus();
//       }
//     });

//     btn.addEventListener('keydown', (e) => {
//       if (e.key === 'Escape') {
//         closeAll();
//         btn.focus();
//       }
//     });

//     menu.addEventListener('keydown', (e) => {
//       if (e.key === 'Escape') {
//         closeAll();
//         btn.focus();
//       }
//     });
//   });

//   // Close when focus leaves the nav entirely
//   nav.addEventListener('focusout', (e) => {
//     if (!nav.contains(e.relatedTarget)) closeAll();
//   });

//   // Close on outside click
//   document.addEventListener('click', (e) => {
//     if (!nav.contains(e.target)) closeAll();
//   });
// })();

// (function () {
//   const nav = document.querySelector('ul.site-nav.site-navigation');
//   if (!nav) return;

//   const items = Array.from(nav.querySelectorAll('li.site-nav__item.site-nav--has-dropdown'));

//   function closeAll(except = null) {
//     items.forEach((li) => {
//       if (except && li === except) return;
//       li.classList.remove('is-open');
//       const btn = li.querySelector('.site-nav__dropdown-toggle');
//       if (btn) btn.setAttribute('aria-expanded', 'false');
//     });
//   }

//   items.forEach((li) => {
//     const btn = li.querySelector('.site-nav__dropdown-toggle');
//     if (!btn) return;

//     btn.setAttribute('aria-expanded', 'false');

//     btn.addEventListener('click', (e) => {
//       e.preventDefault();
//       e.stopPropagation();

//       const willOpen = !li.classList.contains('is-open');
//       closeAll(li);
//       li.classList.toggle('is-open', willOpen);
//       btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
//     });

//     // Close when tabbing away from this li
//     li.addEventListener('focusout', (e) => {
//       if (!li.contains(e.relatedTarget)) {
//         li.classList.remove('is-open');
//         btn.setAttribute('aria-expanded', 'false');
//       }
//     });
//   });

//   document.addEventListener('click', (e) => {
//     if (!nav.contains(e.target)) closeAll();
//   });

//   document.addEventListener('keydown', (e) => {
//     if (e.key === 'Escape') closeAll();
//   });
// })();



// (function () {
//   const OPEN_CLASS = 'is-chevron-open';

//   function closeAll(exceptLi = null) {
//     document.querySelectorAll('.site-nav__item.' + OPEN_CLASS).forEach((li) => {
//       if (exceptLi && li === exceptLi) return;

//       li.classList.remove(OPEN_CLASS);

//       const btn = li.querySelector('.site-nav__dropdown-toggle[aria-controls]');
//       const panelId = btn && btn.getAttribute('aria-controls');
//       const panel = panelId && document.getElementById(panelId);

//       if (btn) btn.setAttribute('aria-expanded', 'false');
//       if (panel) panel.setAttribute('hidden', '');
//     });
//   }

//   function init() {
//     document.querySelectorAll('.site-nav__dropdown-toggle[aria-controls]').forEach((btn) => {
//       if (btn.dataset.chevronBound === '1') return;
//       btn.dataset.chevronBound = '1';

//       const li = btn.closest('.site-nav__item');
//       const id = btn.getAttribute('aria-controls');
//       const panel = document.getElementById(id);
//       if (!li || !panel) return;

//       // Ensure consistent initial state
//       btn.setAttribute('aria-expanded', li.classList.contains(OPEN_CLASS) ? 'true' : 'false');
//       if (!li.classList.contains(OPEN_CLASS)) panel.setAttribute('hidden', '');

//       btn.addEventListener('click', (e) => {
//         e.preventDefault();
//         e.stopPropagation();

//         const isOpen = li.classList.contains(OPEN_CLASS);

//         if (isOpen) {
//           li.classList.remove(OPEN_CLASS);
//           btn.setAttribute('aria-expanded', 'false');
//           panel.setAttribute('hidden', '');
//         } else {
//           closeAll(li);
//           li.classList.add(OPEN_CLASS);
//           btn.setAttribute('aria-expanded', 'true');
//           panel.removeAttribute('hidden');
//         }
//       });
//     });

//     // Close on outside click
//     document.addEventListener('click', () => closeAll(), true);

//     // Close on Escape
//     document.addEventListener('keydown', (e) => {
//       if (e.key === 'Escape') closeAll();
//     });
//   }

//   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
//   else init();

//   document.addEventListener('shopify:section:load', init);
// })();

// (function () {
//   function bind() {
//     document.querySelectorAll('.site-nav__dropdown-toggle[aria-controls]').forEach((btn) => {
//       if (btn.dataset.hiddenSync === '1') return;
//       btn.dataset.hiddenSync = '1';

//       const id = btn.getAttribute('aria-controls');
//       const panel = document.getElementById(id);
//       if (!panel) return;

//       btn.addEventListener('click', () => {
//         const open = btn.getAttribute('aria-expanded') === 'true';
//         if (open) panel.removeAttribute('hidden');
//         else panel.setAttribute('hidden', '');
//       });
//     });
//   }

//   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
//   else bind();

//   document.addEventListener('shopify:section:load', bind);
// })();

function closeItem(li) {
  const btn = li.querySelector('.site-nav__dropdown-toggle[aria-controls]');
  const panel = btn ? document.getElementById(btn.getAttribute('aria-controls')) : null;

  li.classList.remove('is-chevron-open', 'is-open', 'is-focused', 'site-nav--active', 'active');
  if (btn) btn.setAttribute('aria-expanded', 'false');
  if (panel) panel.setAttribute('hidden', '');
}

// Desktop nav dropdowns: chevron controls open/close (single script)
(function () {
  const nav =
    document.querySelector('.site-nav.site-navigation.small--hide') ||
    document.querySelector('ul.site-nav.site-navigation');

  if (!nav) return;

  const OPEN_CLASS = 'is-chevron-open';
  const THEME_OPEN_CLASSES = ['is-open', 'is-focused', 'site-nav--active', 'active', 'site-nav--is-open'];

  function getPanel(btn) {
    const id = btn.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function closeLi(li) {
    const btn = li.querySelector('.site-nav__dropdown-toggle[aria-controls]');
    const panel = btn ? getPanel(btn) : null;

    li.classList.remove(OPEN_CLASS, ...THEME_OPEN_CLASSES);

    if (btn) btn.setAttribute('aria-expanded', 'false');

    if (panel) {
      panel.setAttribute('hidden', '');
      panel.setAttribute('aria-hidden', 'true');
    }
  }

  function openLi(li) {
    const btn = li.querySelector('.site-nav__dropdown-toggle[aria-controls]');
    const panel = btn ? getPanel(btn) : null;
    if (!btn || !panel) return;

    li.classList.add(OPEN_CLASS, 'is-open'); // add is-open for theme CSS compatibility
    btn.setAttribute('aria-expanded', 'true');

    panel.removeAttribute('hidden');
    panel.setAttribute('aria-hidden', 'false');
  }

  function closeAll(exceptLi = null) {
    nav.querySelectorAll('li.site-nav__item.site-nav--has-dropdown').forEach((li) => {
      if (exceptLi && li === exceptLi) return;
      closeLi(li);
    });
  }

  function bind() {
    nav.querySelectorAll('.site-nav__dropdown-toggle[aria-controls]').forEach((btn) => {
      if (btn.dataset.a11yBound === '1') return;
      btn.dataset.a11yBound = '1';

      const li = btn.closest('li.site-nav__item');
      const panel = getPanel(btn);
      if (!li || !panel) return;

      // Start closed
      closeLi(li);

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isOpen =
          btn.getAttribute('aria-expanded') === 'true' ||
          li.classList.contains(OPEN_CLASS);

        if (isOpen) {
          closeLi(li);
        } else {
          closeAll(li);
          openLi(li);
        }
      });

      // Escape closes (while button focused)
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          closeLi(li);
          btn.focus();
        }
      });

      // Escape closes (while inside panel)
      panel.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          closeLi(li);
          btn.focus();
        }
      });
    });
  }

  bind();
  document.addEventListener('shopify:section:load', bind);

  // Close when clicking outside the nav (capture so it wins)
  document.addEventListener(
    'click',
    (e) => {
      if (!nav.contains(e.target)) closeAll();
    },
    true
  );

  // Close when focus leaves the nav (keyboard users)
  nav.addEventListener('focusout', (e) => {
    if (!nav.contains(e.relatedTarget)) closeAll();
  });

  // Global Escape closes anything open
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
})();

// Recently Viewed double callout fix
(function () {
  function patchRecentlyViewedCards(container) {
    var links = container.querySelectorAll('a.grid-product__link');
    links.forEach(function (link) {
      var titleEl = link.querySelector('.grid-product__title');
      var imgEl = link.querySelector('img');
      if (!titleEl || !imgEl) return;

      var productTitle = titleEl.textContent.trim();
      if (!productTitle) return;

      // Add aria-label to the link for a single clean announcement
      link.setAttribute('aria-label', productTitle);

      // Silence the image since the link label covers it
      imgEl.setAttribute('alt', '');

      // Silence the visible title text to avoid double reading
      titleEl.setAttribute('aria-hidden', 'true');
    });
  }

  // Watch for the recently viewed container to be populated
  var container = document.getElementById('RecentlyViewed-recently-viewed');
  if (!container) return;

  var observer = new MutationObserver(function (mutations, obs) {
    var hasCards = container.querySelector('a.grid-product__link');
    if (hasCards) {
      patchRecentlyViewedCards(container);
      obs.disconnect();
    }
  });

  observer.observe(container, { childList: true, subtree: true });
})();